// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, serverTimestamp } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // ✅ AJOUT

const firebaseConfig = {
  apiKey: "AIzaSyChwbG3QG1m4xukci6hxO6vztYdEtiDPPo",
  authDomain: "hadycomeducation.firebaseapp.com",
  projectId: "hadycomeducation",
  storageBucket: "hadycomeducation.appspot.com",
  messagingSenderId: "1020081643229",
  appId: "1:1020081643229:web:4bccbfd937f125bc804534",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); // ✅ AJOUT
export { serverTimestamp };
export default app;
